/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsForSaasAiServices extends models.FilterOptionsForSaasBase {
    getFixupPrototypeFunction() { return FilterOptionsForSaasAiServices.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsForSaasAiServices>): FilterOptionsForSaasAiServices {
        let obj = Object.assign(new FilterOptionsForSaasAiServices(), model);
        FilterOptionsForSaasAiServices.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsForSaasAiServices>): FilterOptionsForSaasAiServices {
        if (!model) return null;
        return FilterOptionsForSaasAiServices.newInstance(<FilterOptionsForSaasAiServices> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsForSaasAiServices) {
        if (!obj) return;

        models.FilterOptionsForSaasAiServices.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsForSaasAiServices): boolean {
        if (models.FilterOptionsForSaasBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FilterOptionsForSaasAiServices.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of SaaS services supported for the role template
     */
    saas: models.SaasAiServiceName;

}
